import React from 'react'
import PropTypes from 'prop-types'
import { IconSLI60Wrapper } from './IconSLI60Wrapper'

export const Icon60Arrow2Right = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLI60Wrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 48 27.91'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M47.870,13.499 C47.883,13.524 47.906,13.543 47.917,13.569 C47.970,13.690 48.000,13.823 48.000,13.963 C48.000,14.103 47.970,14.236 47.917,14.357 C47.908,14.379 47.888,14.395 47.877,14.417 C47.826,14.513 47.769,14.604 47.691,14.679 C47.687,14.683 47.685,14.689 47.681,14.693 L33.681,27.646 C33.488,27.825 33.244,27.913 33.000,27.913 C32.731,27.913 32.464,27.805 32.268,27.594 C31.892,27.191 31.915,26.560 32.319,26.186 L44.453,14.959 L1.000,14.959 C0.447,14.959 -0.000,14.513 -0.000,13.963 C-0.000,13.413 0.447,12.966 1.000,12.966 L44.453,12.966 L32.319,1.740 C31.915,1.365 31.892,0.735 32.268,0.332 C32.642,-0.072 33.276,-0.095 33.681,0.280 L47.681,13.232 C47.686,13.237 47.687,13.243 47.692,13.248 C47.766,13.320 47.821,13.407 47.870,13.499 Z'
        />
      </svg>
    </IconSLI60Wrapper>
  )
}

Icon60Arrow2Right.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
